module.exports = __webpack_public_path__ + "static/img/sunwoo-safety-leadership.58bc639.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing/sunwoo-safety-leadership.jpg
// module id = d/eq
// module chunks = 0